<template>
  <div id="app">
    <Layout></Layout>
    <CookieConsentBanner></CookieConsentBanner>
  </div>
</template>

<script>
import Layout from './components/Layout.vue';
import CookieConsentBanner from './components/CookieConsentBanner.vue';

export default {
  name: 'app',
  components: {
    Layout,
    CookieConsentBanner,
  },
};
</script>

<style lang="scss">
  @import './styles/main.scss';
</style>
